import type { ReactNode } from "react";
import { withPageErrorBoundary } from "utils/errorHandling";
import { SearchProvider, VirtualizedListProvider } from "providers";
import ContactsMetiersFilters from "./components/ContactsMetiersFilters";
import { ContactMetiersTableWithErrorBoundary } from "./components/Table";
import { Box } from "@mui/material";

function RecherchePage(): ReactNode {
  return (
    <SearchProvider>
      <VirtualizedListProvider>
        <Box
          sx={{
            pt: 2,
            height: "100vh",
            display: "flex",
            width: "100%",
            flexFlow: "column",
          }}>
          <ContactsMetiersFilters />
          <ContactMetiersTableWithErrorBoundary />
        </Box>
      </VirtualizedListProvider>
    </SearchProvider>
  );
}

export const RecherchePageWithErrorBoundary = withPageErrorBoundary(RecherchePage);
